/**
 * Locale-aware number formatting for display strings.
 * For 'de': converts decimal '.' to ',' and inserts a non-breaking space before '%'.
 */
export function formatNum(value: string | number, lang: string): string {
  const str = String(value);
  if (lang !== "de") return str;
  return str
    .replace(/(\d)\.(\d)/g, "$1,$2")
    .replace(/(\d)\u00A0?%/g, "$1\u00A0%");
}
